export default {
    messagesPerPage: 50,
    profileSearchFields: ['lastName', 'firstName', 'position'],
    usersPerPage: 20,
}